import {
  Box,
  Typography,
  Button,
  DialogContent,
  DialogActions,
  Dialog,
} from '@mui/material';
import { WarningAmberOutlined } from '@mui/icons-material';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';
import IllustrationWrapper from '../../../../v3/Illustrration/IllustrationWrapper';
import DisclaimerSvg from '../../../../v3/Illustrration/components/DisclaimerSvg';
import { CustomButton } from '../../../MUI_custom_component';
import { useNavigate } from 'react-router-dom';

export default function MaxAgeModal({ showAgeModal, close }) {
  const userData = useSelector(state => state.user?.userData);
  const navigate = useNavigate();

  return (
    <Dialog 
        open={showAgeModal} 
        onClose={close} 
        PaperProps={{
            sx: { borderRadius: 3,
            width:"350px" }
        }}
    >
        <DialogContent sx={{ p: 2 }} >
            <Box sx={{ textAlign: 'center'}}>
                <IllustrationWrapper 
                  illustration={<DisclaimerSvg />}
                  title="Age > 65 years"
                  subtitle="LI/MI beneficiary capture isn't possible as business owner(s) are above 65 years of age."
                />
            </Box>
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <CustomButton
              variant="filled"
              color="primary"
              label="Home"
              onClick={() => navigate("/")}
            />
            <CustomButton
              variant="outlined"
              color="primary"
              label="Cancel"
              onClick={close}
            />
        </Box>
    </Dialog>
  );
}
